module.exports = __webpack_public_path__ + "img/circle-1.f0834e98.png";